import { Heading } from '@chakra-ui/react';
import MyTasksOverviewCard from 'pages/tasks/MyTasksOverviewCard';
import { useTranslation } from 'react-i18next';

import { useUserContext } from '../../../context/UserContextProvider';
import { ContentLayout } from '../../../layout/ContentLayout';
import PageMetatags from '../../../layout/PageMetatags';
import OpenTasksCardsOverview from './OpenTasksCardsOverview';

export enum PagePathMapping {
  service_entry = 'service-record',
  account_registration = 'account',
  service_entry_deletion = 'service-record',
  service_entry_qa = 'service-record',
  verification = 'workshop-verification-request',
  verification_step_1 = 'workshop-verification-request',
  verification_step_2 = 'workshop-verification-request',
  service_history_request = 'service-history-request',
  workshop_data_update = 'workshop-update-request',
  account_deletion = 'account',
  b2c_verification = 'b2c-verification-request',
  b2c_service_history_request = 'b2c-service-history-request',
}

const Dashboard = () => {
  const { t } = useTranslation();
  const userContext = useUserContext();
  const userRoles = userContext?.user?.roles ?? [];
  const hasOpsRole = userRoles.some((role) => role?.name === 'operations');

  return (
    <ContentLayout>
      <PageMetatags title={t('pages:dashboard.meta.title')} />
      <Heading size="sm">{t('pages:dashboard.meta.title')}</Heading>

      <OpenTasksCardsOverview />
      {hasOpsRole && <MyTasksOverviewCard autoFocus />}
    </ContentLayout>
  );
};

export default Dashboard;
